import Form from '@/components/gdl/Form.vue';
import FormField from '@/components/gdl/FormField.vue';

const gdl = {
  gdlForm: Form,
  gdlFormField: FormField,
};

const install = (Vue) => {
  if (install.installed) return;

  Object.keys(gdl).forEach((key) => {
    Vue.component(key, gdl[key]);
  });
};

export default {
  install,
};
